import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';

export const mensajesClasificadosApi = {
  getMensajesClasificados: async (filters = {}) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const {
      tipo_clasificacion,
      fecha_desde,
      fecha_hasta,
      fecha_promesa_desde,
      fecha_promesa_hasta,
      fecha_promesa_hoy,
      solo_cumplimiento_pendiente,
      limit = 100,
      offset = 0,
    } = filters;

    const body = {};
    if (tipo_clasificacion) body.tipo_clasificacion = tipo_clasificacion;
    if (fecha_desde) body.fecha_desde = fecha_desde;
    if (fecha_hasta) body.fecha_hasta = fecha_hasta;
    if (fecha_promesa_desde) body.fecha_promesa_desde = fecha_promesa_desde;
    if (fecha_promesa_hasta) body.fecha_promesa_hasta = fecha_promesa_hasta;
    if (fecha_promesa_hoy === true) body.fecha_promesa_hoy = true;
    if (solo_cumplimiento_pendiente === true) body.solo_cumplimiento_pendiente = true;
    if (limit) body.limit = limit;
    if (offset) body.offset = offset;

    const response = await fetch(`${API_BASE_URL}/api/whatsapp/mensajes-clasificados`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': token,
        'X-Company-ID': user.companyId,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to load mensajes clasificados' }));
      throw new Error(error.error || 'Failed to load mensajes clasificados');
    }

    return response.json();
  },

  updateCumplimientoPromesa: async (clasificacionId, payload) => {
    const token = getToken();
    const user = getUser();

    if (!token) {
      throw new Error('No authentication token');
    }
    if (!user?.companyId) {
      throw new Error('Company ID not available');
    }

    const response = await fetch(
      `${API_BASE_URL}/api/whatsapp/clasificaciones/${encodeURIComponent(clasificacionId)}/cumplimiento`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-Token': token,
          'X-Company-ID': user.companyId,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to update cumplimiento' }));
      throw new Error(error.error || 'Failed to update cumplimiento');
    }

    return response.json();
  },
};

